"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const baseStyle = {
    inputRightElement: { position: 'absolute', height: '100%', top: 'auto', bottom: '0' },
};
const variants = {
    unstyled: {
        _focus: { boxShadow: 'none' },
        size: 'sm',
        pr: 2,
    },
};
const FormInputPasswordStyle = {
    variants,
    baseStyle,
};
exports.default = FormInputPasswordStyle;
